"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessSortFieldToJSON = exports.BusinessSortFieldFromJSONTyped = exports.BusinessSortFieldFromJSON = exports.BusinessSortField = void 0;
/**
 *
 * @export
 */
exports.BusinessSortField = {
    CreatedAt: 'CREATED_AT',
    UpdatedAt: 'UPDATED_AT',
    Type: 'TYPE',
    Name: 'NAME'
};
function BusinessSortFieldFromJSON(json) {
    return BusinessSortFieldFromJSONTyped(json, false);
}
exports.BusinessSortFieldFromJSON = BusinessSortFieldFromJSON;
function BusinessSortFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BusinessSortFieldFromJSONTyped = BusinessSortFieldFromJSONTyped;
function BusinessSortFieldToJSON(value) {
    return value;
}
exports.BusinessSortFieldToJSON = BusinessSortFieldToJSON;
